import { getScreenName } from '../../../Utils/helper';

import { fireEvent } from '../../../Utils/fireEvent';

export const viewedScreenEvent = (homePage, query, saved) => {
  fireEvent({
    category: 'viewed_general_screen',
    screen_name: getScreenName(),
    query: query,
    saved: saved,
    screen_type: homePage ? 'Tool' : 'Tool Subpage',
  });
  // in case of search just send search query
  // and in case of starting with screen send "starting with" + alphabet
};

export const servedSectionEvent = (homePage, section_name, card_ids) => {
  fireEvent({
    category: 'served_section_in_general_screen',
    screen_name: getScreenName(),
    screen_type: homePage ? 'Tool' : 'Tool Subpage',
    section_name: section_name,
    card_ids: card_ids,
  });
};
export const clickedSectionEvent = (
  homePage,
  section_name,
  card_id,
  card_name,
) => {
  fireEvent({
    category: 'clicked_card_in_general_screen',
    screen_name: getScreenName(),
    screen_type: homePage ? 'Tool' : 'Tool Subpage',
    section_name: section_name,
    card_id: card_id,
    card_name: card_name,
  });
};

export const clickedCtaEvent = (homePage, section_name, cta) => {
  fireEvent({
    category: 'clicked_cta',
    screen_name: getScreenName(),
    screen_type: homePage ? 'Tool' : 'Tool Subpage',
    section_name: section_name,
    cta: cta,
  });
};

export const saveNameEvent = (homePage, card_name, card_id) => {
  fireEvent({
    category: 'save_name',
    screen_name: getScreenName(),
    screen_type: homePage ? 'Tool' : 'Tool Subpage',
    card_name: card_name,
    card_id: card_id,
  });
};

export const pageClickEvent = (pageNo) => {
  fireEvent({
    category: 'clicked_cta',
    cta: pageNo,
    parent: 'select page number',
    screen_name: getScreenName(),
    section_name: 'pagination',
  });
};
